import { InsuranceLoanWaiverService } from '@/modules/global-settings/loan-origination/services/security-policies/insurance-waiver.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
const insuranceLoanWaiverService = new InsuranceLoanWaiverService();
export const state = {
  insuranceLoanWaiverSettings: []
};
export const mutations = {
  ...make.mutations(state)
};
export const actions = {
  // Get all waivers
  getInsuranceLoanWaiverSettings: async ({ commit }) => {
    try {
      const { data } =
        await insuranceLoanWaiverService.getInsuranceLoanWaiverSettings();
      commit('SET_INSURANCE_LOAN_WAIVER_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting insurance loan waiver settings', error);
      throw error;
    }
  },
  // Create a new waiver
  createInsuranceLoanWaiverSetting: async ({ dispatch }, payload) => {
    try {
      const { data } =
        await insuranceLoanWaiverService.createInsuranceLoanWaiverSetting(
          payload
        );
      dispatch('getInsuranceLoanWaiverSettings');
      return data;
    } catch (error) {
      Logger.error('creating insurance loan waiver settings', error);
      throw error;
    }
  },
  // Update waiver
  updateInsuranceLoanWaiverSetting: async ({ dispatch }, payload) => {
    try {
      await insuranceLoanWaiverService.updateInsuranceLoanWaiverSetting(
        payload
      );
      dispatch('getInsuranceLoanWaiverSettings');
    } catch (error) {
      Logger.error('updating insurance loan waiver settings', error);
      throw error;
    }
  }
};
export const getters = make.getters(state);
